// prettifyStance 将 LLM 风控三角 JSON 回复转成可读文字
//   '{"riskScore":3,"concern":"PE 缺乏盈利支撑…","positionSuggestion":"维持"}'
//   → "风险评分 3/5 · 仓位建议 维持 · 风险点: PE 缺乏盈利支撑…"
export function prettifyStance(raw: string): string {
  const trimmed = String(raw || '').trim();
  if (!trimmed) return '';
  const start = trimmed.indexOf('{');
  const end = trimmed.lastIndexOf('}');
  if (start < 0 || end <= start) return trimmed;
  const prefix = trimmed.slice(0, start).trim();
  try {
    const obj = JSON.parse(trimmed.slice(start, end + 1)) as {
      riskScore?: number; concern?: string; positionSuggestion?: string;
      reasoning?: string;
    };
    const bits: string[] = [];
    if (typeof obj.riskScore === 'number') {
      bits.push(`风险评分 ${obj.riskScore}/5`);
    }
    if (obj.positionSuggestion) {
      bits.push(`仓位建议 ${obj.positionSuggestion}`);
    }
    if (obj.concern) {
      bits.push(`风险点: ${obj.concern}`);
    }
    if (obj.reasoning && !obj.concern) {
      bits.push(obj.reasoning);
    }
    const body = bits.length > 0 ? bits.join(' · ') : trimmed;
    return prefix ? `${prefix} · ${body}` : body;
  } catch {
    return trimmed;
  }
}
